export default "__VITE_ASSET__BlBrSavS__"